import { StackProps } from '@chakra-ui/react';
import type { BaseHit, Hit as TypesenseHit } from 'instantsearch.js';
import { useHits, useSearchBox } from 'react-instantsearch-hooks';

import { ReactSelectProps } from '../../utils/types';
import { SimpleReactSelect } from '../SimpleReactSelect';

type Hit = {
  label: string;
  value: string;
};

export type InputProps = ReactSelectProps &
  StackProps & {
    name: string;
    isDisabled?: boolean;
  };

type Props<TSType extends BaseHit> = {
  hitMap: <T extends TypesenseHit<TSType>>(hits: T[]) => Hit[];
  name: string;
  isDisabled?: boolean;
  isMulti?: boolean;
  isPortaled?: boolean;
};

export const InputAutocomplete = <TSType extends BaseHit>({
  name,
  isMulti = false,
  hitMap,
  ...rest
}: Props<TSType>) => {
  const { hits } = useHits<TSType>();
  const { refine } = useSearchBox();

  const handleInputChange = (inputValue: string) => {
    refine(inputValue);
  };

  return (
    <SimpleReactSelect
      options={hitMap(hits)}
      onInputChange={handleInputChange}
      name={name}
      isMulti={isMulti}
      {...rest}
    />
  );
};
